import "./Property.css";

export default function RumiProp() {
  return (
    <section>
      <header className="tm__hero">
        <h1 className="tm__title">Vì sao chọn Rumi</h1>
        <p className="tm__subtitle">
          Bỉm Rumi với nhiều đặc tính cao cấp luôn mang đến sự thoải mái dễ chịu
          cho bé.
        </p>
      </header>

      {/* Row A */}
      <div className="tm__row">
        <div className="tm__imageCard tm__imageCard--left">
          <div className="tm__circle tm__circle--a" />
          <img
            src="/images/proper/thamhut.png"
            alt="Sunny-side-up egg on a plate"
            className="tm__img tm__img--float"
          />
        </div>

        <div className="tm__copy">
          <span className="tm__number">Siêu Thấm Hút</span>
          <p className="tm__kicker">
            💦 Bề mặt tã vân 3D với 5000 lỗ thoáng làm giảm điểm tiếp xúc, giúp
            bề mặt thấm hút siêu nhanh và siêu thoáng khí.
          </p>

          {/* 2) Icon button (màu theo --accent) */}
        </div>

        <div className="tm__tiny tm__tiny--cubes tm__img--float">
          <img
            className="tm__bowl"
            src="/images/material/sun.png"
            alt="decor"
          />
          <div className="tm__cube" />
          <div className="tm__cube tm__cube--2" />
        </div>
      </div>

      {/* Row B */}
      <div className="tm__row tm__row--reverse">
        <div className="tm__imageCard tm__imageCard--right">
          <div className="tm__circle tm__circle--b" />
          <img
            src="/images/proper/mem.png"
            alt="Neutral tone food jar"
            className="tm__img tm__img--float tm__img--delay"
          />
        </div>

        <div className="tm__copy">
          <span className="tm__number">Siêu Mềm Mại</span>
          <p className="tm__kicker">
            ☁️ Chất liệu vải dệt nhiệt siêu mềm mịn nên khi tiếp xúc với da
            không cọ xát khiến con khó chịu hay làm tấy đỏ da.
          </p>
        </div>

        <div className="tm__tiny tm__tiny--tomato tm__img--float">
          <div className="tm__tinyPlate" />
          <div className="tm__tomato" />
        </div>
      </div>

      {/* Row C */}
      <div className="tm__row">
        <div className="tm__imageCard tm__imageCard--left">
          <div className="tm__circle tm__circle--c" />
          <img
            src="/images/proper/thoang_mong.png"
            alt="Sliced bread with cutlery"
            className="tm__img tm__img--float tm__img--delay2"
          />
        </div>

        <div className="tm__copy">
          <span className="tm__number">Siêu Thoáng</span>
          <p className="tm__kicker">
            🎗️ Bỉm có cấu tạo siêu mỏng chỉ 1.5mm, giúp con luôn có cảm giác nhẹ
            nhàng, thoáng khí và thoải mái vận động.
          </p>
        </div>

        <div className="tm__tiny tm__tiny--cubes">
          <img
            className="tm__img--float"
            src="/images/material/decor.png"
            alt="decor"
          />
        </div>
      </div>

      {/* Row D */}
      <div className="tm__row tm__row--reverse">
        <div className="tm__imageCard tm__imageCard--right">
          <div className="tm__circle tm__circle--d" />
          <img
            src="/images/proper/daichun.png"
            alt="Neutral tone food jar"
            className="tm__img tm__img--float tm__img--delay"
          />
        </div>

        <div className="tm__copy">
          <span className="tm__number">Đai Chun Không Áp Lực</span>
          <p className="tm__kicker">
            😶‍🌫️ Đai chun không áp lực cho bé cảm nhận được sự êm ái tuyệt đối, co
            giãn linh hoạt, ôm sát cơ thể, không gây hằn đỏ lưng nhưng vẫn thoải
            mái vận động.
          </p>
        </div>

        <div className="tm__tiny tm__tiny--tomato">
          <img
            className="tm__img--float"
            src="/images/material/cloud.png"
            alt="cloud"
          />
        </div>
      </div>
    </section>
  );
}
